/**
 * A utility for determining if we're sending a request to an API endpoint
 */
export const isAPIURL = (url: string) => url.includes("/api/");
